/**
 * Setting store and branding type apply to all items
 * @type {{'5r19rpx': string[]}}
 */
const applyBrandingForAllItemsConfig = {
    '5r19rpx': ['BRAND_KIT']
}

/**
 * Check an order or barcode support branding for all items
 *
 * @param {Object|Array} barcodeOrOrders
 * @return {boolean|*}
 */
export const isSupport = (barcodeOrOrders) => {
    if(!barcodeOrOrders){
        return false
    }

    console.log({barcodeOrOrders})
    // is 3D orders
    if (Array.isArray(barcodeOrOrders)) {
        const namespace = barcodeOrOrders[0].namespace

        return Array.isArray(applyBrandingForAllItemsConfig[namespace]) && barcodeOrOrders.some(order => applyBrandingForAllItemsConfig[namespace].includes(order.type))
    }

    const {
        // FAC
        storename,
        products = [],
    } = {...barcodeOrOrders}

    return Array.isArray(applyBrandingForAllItemsConfig[storename]) && products.some(product => {
        return applyBrandingForAllItemsConfig[storename].includes(product.type)
    })
}

export default applyBrandingForAllItemsConfig